import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import {DeviceService} from '@app/core/services/device.service';
import {NGXLogger} from 'ngx-logger';
import {DeviceType} from '@app/core/models/device';
import { map } from 'rxjs/operators';
import { Kind } from '../models/kind';
import {ScgHttpWrapper} from '@app/core/injectables/scg-http-wrapper';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private scgHttp: ScgHttpWrapper,
              private device: DeviceService,
              private log: NGXLogger) {
  }

  /**
   * Accepts all settings params because they are converted to the needed param type (CB or CC)
   */
  public getSettings(params: (CbSettingsParams|CcSettingsParams)[]): Observable<CbSettings|CcSettings|null> {

    if (this.device.activeDevice?.device.type === DeviceType.CC) {
      const keys = params.join('&key=');
      return this.scgHttp.get<CcSettings>(environment.apiUrl + this.device.activeDevice.username + '/ccsettings?key=' + keys);
    } else if (this.device.activeDevice?.device.type === DeviceType.CB) {
      this.log.info('params before:' , params);
      params = this.mapCCParamsToCBParams(params);
      const keys = params.join('&key=');
      this.log.info('params after:' , params);
      this.log.info('getSettings - we are CB device requested params=' + params);
      return this.scgHttp.get<CbSettings>(environment.apiUrl + 'cbsettings?key=' + keys);
    } else {
      this.log.error('getSettings falied: No activeDevice available');
      return of(null);
    }
  }

  public assignResponse(){

  }

  public mapCCParamsToCBParams(params: (CcSettingsParams|CbSettingsParams)[]): any {
    const retvalParams = [];
    for (const item of params) {
      // this.log.info('inside params each, item=', item);
      if (item === CcSettingsParams.isTimeLimitActive) {retvalParams.push(CbSettingsParams.IsTimeLimitActiveDevice); }
      else if (item === CcSettingsParams.TimeLimitDay) {retvalParams.push(CbSettingsParams.TimeLimitDayDevice); }
      else if (item === CcSettingsParams.blockTimesPC) {retvalParams.push(CbSettingsParams.blockTimesDevice); }
      else {retvalParams.push(item); }
    }
    return retvalParams;
  }

  public getCbSettings(params: CbSettingsParams[]): Observable<CbSettings> {
    const keys = params.join('&key=');
    return this.scgHttp.get<CbSettings>(environment.apiUrl + 'cbsettings?key=' + keys);
  }

  public getCbSettingsWithDevice(deviceId: string, params: CbSettingsParams[]): Observable<CbSettings> {
    const keys = params.join('&key=');
    return this.scgHttp.withDevice(deviceId).get<CbSettings>(environment.apiUrl + '/cbsettings?key=' + keys);
  }

  public getCcSettings(params: CcSettingsParams[]): Observable<CcSettings> {
    const keys = params.join('&key=');
    return this.scgHttp.get<CcSettings>(environment.apiUrl + this.device.activeDevice.username + '/ccsettings?key=' + keys);
  }

  public getCcSettingsWithDevice(deviceId: string, username: string, params: CcSettingsParams[]): Observable<CcSettings> {
    const keys = params.join('&key=');
    return this.scgHttp.withDevice(deviceId).withUsername(username).get('ccsettings?key=' + keys);
  }


  public getCcAllSettings(params: CcSettingsParams[]): Observable<CcSettings> {
    const keys = params.join('&key=');
    return this.scgHttp.get<CcSettings>(environment.apiUrl + 'allusers/ccsettings?key=' + keys);
  }

  public getCcAllSettingsWithDevice(deviceId: string, params: CcSettingsParams[]): Observable<CcSettings> {
    const keys = params.join('&key=');
    return this.scgHttp.withDevice(deviceId).get<CcSettings>(environment.apiUrl + 'allusers/ccsettings?key=' + keys);
  }

  public setCbSettings(settings: CbSettings): Observable<any> {
    return this.scgHttp.post(environment.apiUrl + 'cbsettings', settings);
  }

  public setCbSettingsWithDevice(deviceId: string, settings: CbSettings): Observable<any> {
    return this.scgHttp.withDevice(deviceId).post(environment.apiUrl + 'cbsettings', settings);
  }

  public getCbHint(id: number): Observable<any> {
    return this.scgHttp.get<any>(environment.apiUrl + 'cbsettings?key=' + 'hint' + id.toString());
  }

  public getWebKeywordsCB(): Observable<string[]> {
    return this.scgHttp.get<string[]>(environment.apiUrl + 'weblist/keywords');
  }

  public deleteWebKeywordsCB(): Observable<string[]> {
  return this.scgHttp.get<any>(environment.apiUrl + 'weblist/deleteallkeywords');
  }

  public deleteWebKeywordsCC(): Observable<string[]> {
    return this.scgHttp.get<any>(environment.apiUrl +  this.device.activeDevice.username + '/weblist/deleteallkeywords');
  }

  public addWebKeywordsCB(entry: string): Observable<any> {
    const postVal = [];
    postVal.push(entry);
    return this.scgHttp.post<any>(environment.apiUrl + 'weblist/keywords', postVal);
  }

  public addWebKeywordsCC(entry: string): Observable<any> {
    const postVal = [];
    postVal.push(entry);
    return this.scgHttp.post<any>(environment.apiUrl +  this.device.activeDevice.username + '/weblist/keywords', postVal);
  }

  public delWebKeywordsCB(entry: string): Observable<any> {
    const postVal = [];
    postVal.push(entry);
    return this.scgHttp.post(environment.apiUrl + 'weblist/keywords/delete', postVal);
  }

  public delWebKeywordsCC(entry: string): Observable<any> {
    const postVal = [];
    postVal.push(entry);
    return this.scgHttp.post(environment.apiUrl +  this.device.activeDevice.username + '/weblist/keywords/delete', postVal);
  }

  public getWebKeywordsCC(): Observable<string[]> {
    return this.scgHttp.get<string[]>(environment.apiUrl +  this.device.activeDevice.username + '/weblist/keywords');
  }

  public setCbHint(id: number): Observable<any> {
    const idStr = `hint${id}`;
    const postVal = {};
    postVal[idStr] = true;
    return this.scgHttp.post(environment.apiUrl + 'cbsettings', postVal);
  }

  public resetCbHint(id: number): Observable<any> {
    const idStr = `hint${id}`;
    const postVal = {};
    postVal[idStr] = false;
    return this.scgHttp.post(environment.apiUrl + 'cbsettings', postVal);
  }

  public setCcSettings(settings: CcSettings): Observable<any> {
    return this.scgHttp.post(environment.apiUrl + this.device.activeDevice.username + '/ccsettings', settings);
  }

  public setCcSettingsWithDevice(deviceId: string, username: string, settings: CcSettings): Observable<any> {
    return this.scgHttp.withDevice(deviceId).withUsername(username).post('ccsettings', settings);
  }

  public setCcAllSettings(settings: CcSettings): Observable<any> {
    return this.scgHttp.post(environment.apiUrl + 'allusers/ccsettings/', settings);
  }

  public setCcAllSettingsWithDevice(deviceId: string, settings: CcSettings): Observable<any> {
    return this.scgHttp.withDevice(deviceId).post(environment.apiUrl + 'allusers/ccsettings/', settings);
  }

  public getErrBodyMax(deviceId: string): Observable<any> {
    return this.scgHttp.withDevice(deviceId).get(environment.apiUrl + 'cbsettings/errbodymax');
  }
}

export interface CbSettings {
  // See also CBSetDefault.JSON template in backend
  untilDateTime?: string;
  isTimeLimitActiveDevice?: boolean;
  timeLimitDayDevice?: string;
  timeLimitWeekDevice?: string;
  timeLimitMonthDevice?: string;
  /** Legacy */
  isWeekDayLimitActive?: boolean;
  isWeekDayLimitActiveDevice?: boolean;
  timeLimitMondayDevice?: string;
  timeLimitTuesdayDevice?: string;
  timeLimitWednesdayDevice?: string;
  timeLimitThursdayDevice?: string;
  timeLimitFridayDevice?: string;
  timeLimitSaturdayDevice?: string;
  timeLimitSundayDevice?: string;

  extension?: number;
  blockTimesBrowser?: string;
  untilAction?: number;
  roaming?: string;
  isTimeLimitActive?: boolean;
  isHackScreen?: boolean;
  datetimehack?: boolean;
  infoblocktimesdevice?: boolean;
  /**
   * Not needed because version can be queried via the device
   * @deprecated
   */
  hascb2installed?: boolean;
  currentextensionmin?: number;
  blockTimesDevice?: string;
  isLatestVersion?: boolean;
  tancount?: number;
  currentExtensionMin?: -1;
  currentExtensionStartDate?: string;
  currentExtensionEndDate?: string;
  customBlockMsg?: string;
  disableswipeprotection?: boolean;
  disablenotificationbar?: boolean;
  enableusagestatscouting ?: boolean;
  forceBreakAfter?: string;
  forceBreakDuration?: string;
  generalWarn1?: boolean;
  generalWarn2?: boolean;
  generalWarn3?: boolean;
  generalWarn5?: boolean;
  generalWarn3Value?: number;
  generalWarn5Value?: number;
  generalPauseTimersLevel?: number;
  groupnames?: string;
  giveExt?: number;
  hideViewReports?: boolean;
  hideViewLimits?: boolean;
  hideExtensionRequest?: boolean;
  hidePasswordForgotten?: boolean;
  hasRoaming?: boolean;
  hasCrackProtection?: boolean;
  imgBackgroundURL?: string;
  imgBackgroundColor?: string;
  imgBackgroundOption?: number;
  isUsageDisabled?: boolean;
  isWebFilterActive?: boolean;
  isWebLogActive?: boolean;
  isNewWebsitesBlocked?: boolean;
  isAppFilterActive?: boolean;
  isAppFilterNewBlocked?: boolean;
  isEmailReportActive?: boolean;
  isPasswordLocked?: boolean;
  isForcedBreak?: boolean;
  emailReportRecipient?: string;
  emailReportCC?: string;
  emailReportSubject?: string;
  forceFastboot?: boolean;
  isEmailReportDay?: boolean;
  isEmailReportWeek?: boolean;
  isEmailReportUnlockMsg?: boolean;
  hideUsageAny?: boolean;
  hideUsageRuntimePrograms?: boolean;
  hideUsageRuntimeWebsites?: boolean;
  hideUsageHistoryPrograms?: boolean;
  hideUsageHistoryWebsites?: boolean;
  hideUsageHistoryBlocked?: boolean;
  hideUsageHistorySystem?: boolean;
  neverBlockAlwaysAllowed?: boolean;
  noBonusNotification?: boolean;
  noExtensionInBlockTime?: boolean;
  noExtensionInPause?: boolean;
  noExtensionDeleteAuto?: boolean;
  noBlockNotification?: boolean;
  alwaysBlockNotification ?: boolean;
  noBlockDualScreen?: boolean;
  noAppsInBlockTime?: boolean;
  noNotificationBar?: boolean;
  noProtectSettings?: boolean;
  noWhatsappVideo?: boolean;
  protectSettingsLevel?: number;
  oneSecInterval?: number;

  samsecDisableFactoryReset?: boolean;
  samsecDisableSafeMode?: boolean;
  samsecDisableDateTime?: boolean;
  samsecDisableSettings?: boolean;
  samsecForceGPS?: boolean;
  samsecDisableAirplaneMode?: boolean;
  samsecDisableMultiWindow?: boolean;
  samsecDisableMultiUser?: boolean;
  samsecDisablePinApp?: boolean;
  samsecDisableApps?: boolean;
  samsecWantIt?: boolean;

  isSoundLimitGeneral?: boolean;
  isSoundTimeLimitActive?: boolean;
  isSoundWeekdayLimitActive?: boolean;
  noExtensionInSoundLimit?: boolean;
  soundLimitDay?: string;
  soundLimitWeek?: string;
  soundLimitMonth?: string;
  soundLimitMonday?: string;
  soundLimitTuesday?: string;
  soundLimitWednesday?: string;
  soundLimitThursday?: string;
  soundLimitFriday?: string;
  soundLimitSaturday?: string;
  soundLimitSunday?: string;
  soundBlockTimes?: string;
  noAudioStopV2?: boolean;

  webDisableSSL?: boolean;
  webBlockedCategory11?: boolean;
  webBlockedCategory12?: boolean;
  webBlockedCategory13?: boolean;
  webBlockedCategory14?: boolean;
  webBlockedCategory15?: boolean;
  webBlockedCategory16?: boolean;
  webBlockedCategory17?: boolean;
  webBlockedCategory18?: boolean;
  webBlockedCategory19?: boolean;
  webBlockedCategory20?: boolean;
  webBlockedCategory21?: boolean;
  webBlockedCategory22?: boolean;
  webBlockedCategory23?: boolean;
  webBlockedCategory24?: boolean;
  webBlockedCategory25?: boolean;
  webBlockedCategory26?: boolean;
  webBlockedCategory27?: boolean;
  webBlockedCategory28?: boolean;
  webBlockedCategory29?: boolean;
  webBlockedCategory30?: boolean;
  webBlockedCategory31?: boolean;
  webBlockedCategory32?: boolean;
  webBlockedCategory33?: boolean;
  webBlockedCategory34?: boolean;
  webBlockedCategory35?: boolean;
  webFilterAge?: number;
  webFilterAgeNotifyOpt?: number;
  isActive?: boolean;
  blockedUntil?: string;
  defaultAppKind?: number;
  showAlwaysEntries?: boolean;
  screenshotInterval?: number;
  screenshotActive?: boolean;
  screenshotWifiOnly?: boolean;
  screenshotRightSuccess?: boolean;

  wakeupDevice?: boolean;
  noAudioStop?: boolean;
  preferAccPkg?: boolean;
  appCheckLevel?: number;
  disablePopup?: boolean;
  warnAsToast?: boolean;

  overrideScreenOn?: boolean;
  overrideOurPkg?: boolean;
  overrideSysApp?: boolean;
  overrideDeviceLocked?: boolean;
  overrideForeground?: boolean;
  overridePhone?: boolean;
  overrideNullPkg?: boolean;

  manipulationDuration?: number;
  notificationBlockLevel?: number;
  bonusBarPosition?: number;
  forcePortraitBlock?: boolean;
  timecountv2?: boolean;
  debugterm?: string;
  disableSplitLock?: boolean;
  disableCb3Counting?: boolean;
  hideUnblockRequest?: boolean;
  tanOffline?: boolean;
  webfilterLevel?: number;
  isAnySecurity?: boolean;
  isPlayStoreVersion?: boolean;
  showCardSecurityChecks?: boolean;
  forceUI25?: boolean;
  forceLegacyOverlay?: boolean;
  wideBackground?: boolean;
}


export interface CcSettings {
  blockTimesPC?: string;
  isTimeLimitActive?: boolean;
  timeLimitDay?: string;
  timeLimitWeek?: string;
  timeLimitMonth?: string;
  isWeekdayLimitActive?: boolean;
  timeLimitMonday?: string;
  timeLimitTuesday?: string;
  timeLimitWednesday?: string;
  timeLimitThursday?: string;
  timeLimitFriday?: string;
  timeLimitSaturday?: string;
  timeLimitSunday?: string;

  // Misc stuff (not from template json)
  isforcedbreak?: boolean;
  hasunlockreq?: boolean;
  unlockdate?: string;
  roaming?: string;
  onetimelocklevel?: number;
  datetimehack?: boolean;
  lockdate?: string;
  isLatestVersion?: boolean;
  tancount?: number;

  // CCSetAllDefault.json from template backend
  hasChangedCCSET?: boolean;
  isSecDisableSafeBoot?: boolean;
  isSecDisableSysRestore?: boolean;
  isSecDisableFastUserSwitching?: boolean;
  SecLevel?: number;
  generalWarn1?: boolean;
  generalWarn2?: boolean;
  generalWarn3?: boolean;
  generalWarn5?: boolean;
  generalWarn3Value?: number;
  generalWarn5Value?: number;
  generalBeepValue?: number;

  hideViewReports?: boolean;
  hideViewLimits?: boolean;
  hideExtensionRequest?: boolean;
  hidePasswordForgotten?: boolean;
  hideUnblockRequest?: boolean;

  imgBackgroundURL?: string;
  imgBackgroundColor?: string;
  imgBackgroundOption?: number;
  isGeneralNoDeleteExtensionAuto?: boolean;
  isGeneralStealthMode?: boolean;
  isGeneralAutoHideWarnings?: boolean;
  isGeneralBeepForWarnings?: boolean;
  isGeneralNoNewUsers?: boolean;
  isPasswordLocked?: boolean;
  generalPCLimitLevel?: number;
  generalInternetLimitLevel?: number;
  generalForcedBreaksLevel?: number;
  generalPauseTimersLevel?: number;
  generalVacationLevel?: number;
  generalDeleteLogsLevel?: number;
  generalCountdownLevel?: number;
  groupnames?: string;
  remoteDebugLevel?: number;
  noAudioStop?: boolean;
  cloneMode?: string;
  extension?: number;
  noTerminateLockScreen?: boolean;

  // CCSetDefault.json from template backend
  isForcedBreak?: boolean;
  forceBreakAfter?: string;
  forceBreakDuration?: string;
  giveExt?: number;
  hasRoaming?: boolean;
  isCountdown?: boolean;
  countdownTime?: number;
  OneTimeLockLevel?: number;
  LockDate?: string;
  UnlockDate?: string;
  isWebFilterActive?: boolean;
  isWebLogActive?: boolean;
  isNewWebsitesBlocked?: boolean;
  isAppStoreBlocked?: boolean;
  neverBlockAlwaysAllowed?: boolean;
  noExtensionInBlockTime?: boolean;
  noAppsInBlockTime?: boolean;
  noAppsInPause?: boolean;
  noExtensionInPause?: boolean;
  webFilterAge?: number;
  webFilterAgeNotifyOpt?: number;
  webNoWarning?: boolean;
  webNeutralWarning?: boolean;
  webNoHttps?: boolean;
  webNoIP?: boolean;
  webCheckAllowedKeyword?: boolean;
  webKeywordsSearchOnly?: boolean;
  webNoDownload?: boolean;
  webDisableSSL?: boolean;
  webRedirect?: boolean;
  webRedirectBlockpage?: boolean;
  webRedirectUrl?: string;
  webdeepscan?: boolean;
  webNoDynamicWhitelist?: boolean;
  webKeywordsGlobal?: boolean;
  webFilterAllApps?: boolean;
  isPrgFilterActive?: boolean;
  isPrgFilterNewBlocked?: boolean;
  programFilterAge?: number;
  programFilterAgeNotifyOpt?: number;
  isDisableCMD?: boolean;
  isDisableRegedit?: boolean;
  isDisableControlPanel?: boolean;
  isDisableUserAccounts?: boolean;
  isDisableStartRun?: boolean;
  isDisableStartSearch?: boolean;
  isDisableTaskmanager?: boolean;
  isDisableIcon?: boolean;
  isDisableMSStore?: boolean;
  isDisableTimeDate?: boolean;
  isDisableLockStation?: boolean;
  isNoDeleteChicoSys?: boolean;
  isNoDeleteChicoStart?: boolean;
  isUsageDisabled?: boolean;
  defaultAppKind?: number;
  DrvLock?: string;
  isEmailReportActive?: boolean;
  emailReportRecipient?: string;
  emailReportCC?: string;
  emailReportSubject?: string;
  isEmailReportDay?: boolean;
  isEmailReportWeek?: boolean;
  isEmailReportUnlockMsg?: boolean;
  isEmailReportStart?: boolean;
  isEmailReportStop?: boolean;
  isEmailReportSystemMsg?: boolean;
  NFSOff?: boolean;
  noCheckUrlFallback?: boolean;
  nfsAutoInetPRG?: boolean;
  noInject?: boolean;
  screenshotactive?: boolean;
  screenshotinterval?: number;
  hideUsageAny?: boolean;
  hideUsageRuntimePrograms?: boolean;
  hideUsageRuntimeWebsites?: boolean;
  hideUsageHistoryPrograms?: boolean;
  hideUsageHistoryWebsites?: boolean;
  hideUsageHistoryBlocked?: boolean;
  hideUsageHistorySystem?: boolean;
  webBlockedCategory11?: boolean;
  webBlockedCategory12?: boolean;
  webBlockedCategory13?: boolean;
  webBlockedCategory14?: boolean;
  webBlockedCategory15?: boolean;
  webBlockedCategory16?: boolean;
  webBlockedCategory17?: boolean;
  webBlockedCategory18?: boolean;
  webBlockedCategory19?: boolean;
  webBlockedCategory20?: boolean;
  webBlockedCategory21?: boolean;
  webBlockedCategory22?: boolean;
  webBlockedCategory23?: boolean;
  webBlockedCategory24?: boolean;
  webBlockedCategory25?: boolean;
  webBlockedCategory26?: boolean;
  webBlockedCategory27?: boolean;
  webBlockedCategory28?: boolean;
  webBlockedCategory29?: boolean;
  webBlockedCategory30?: boolean;
  webBlockedCategory31?: boolean;
  webBlockedCategory32?: boolean;
  webBlockedCategory33?: boolean;
  webBlockedCategory34?: boolean;
  webBlockedCategory35?: boolean;
  debugterm?: string;
  tanOffline?: boolean;
  webfilterLevel?: number;
  isAnySecurity?: boolean;
  webSafeSearch?: boolean;
  forceUI25?: boolean;
  forceLegacyOverlay?: boolean;
  wideBackground?: boolean;
}

export enum CbSettingsParams {
  IsTimeLimitActive = 'isTimeLimitActive',
  IsWeekDayLimitActive = 'isWeekDayLimitActive',
  IsTimeLimitActiveDevice = 'isTimeLimitActiveDevice',
  TimeLimitDayDevice = 'timeLimitDayDevice',
  TimeLimitWeekDevice = 'timeLimitWeekDevice',
  TimeLimitMonthDevice = 'timeLimitMonthDevice',
  IsWeekDayLimitActiveDevice = 'isWeekDayLimitActiveDevice',
  TimeLimitMondayDevice = 'timeLimitMondayDevice',
  TimeLimitTuesdayDevice = 'timeLimitTuesdayDevice',
  TimeLimitWednesdayDevice = 'timeLimitWednesdayDevice',
  TimeLimitThursdayDevice = 'timeLimitThursdayDevice',
  TimeLimitFridayDevice = 'timeLimitFridayDevice',
  TimeLimitSaturdayDevice = 'timeLimitSaturdayDevice',
  TimeLimitSundayDevice = 'timeLimitSundayDevice',
  blockTimesBrowser= 'blockTimesBrowser',
  drvLock = 'DrvLock',
  untilAction= 'untilAction',
  untilDateTime = 'untilDateTime',
  customBlockMsg = 'customBlockMsg',
  roaming= 'roaming',
  isTimeLimitActive= 'isTimeLimitActive',
  isTimeLimitActiveDevice= 'isTimeLimitActiveDevice',
  isWeekDayLimitActive = 'isWeekDayLimitActive',
  isWeekDayLimitActiveDevice = 'isWeekDayLimitActiveDevice',
  isHackScreen= 'isHackScreen',
  datetimehack= 'datetimehack',
  infoblocktimesdevice= 'infoblocktimesdevice',
  hascb2installed= 'hascb2installed',
  currentextensionmin= 'currentextensionmin',
  blockTimesDevice= 'blockTimesDevice',
  isLatestVersion= 'isLatestVersion',
  tancount= 'tancount',
  extension= 'extension',
  currentExtensionMin= 'currentExtensionMin',
  currentExtensionStartDate= 'currentExtensionStartDate',
  currentExtensionEndDate= 'currentExtensionEndDate',
  disableswipeprotection= 'disableswipeprotection',
  disablenotificationbar= 'disablenotificationbar',
  enableusagestatscouting = 'enableusagestatscouting',
  forceBreakAfter= 'forceBreakAfter',
  forceBreakDuration= 'forceBreakDuration',
  generalWarn1= 'generalWarn1',
  generalWarn2= 'generalWarn2',
  generalWarn3= 'generalWarn3',
  generalWarn5= 'generalWarn5',
  generalWarn3Value= 'generalWarn3Value',
  generalWarn5Value= 'generalWarn5Value',
  hideViewLimits = 'hideViewLimits',
  hideViewReports = 'hideViewReports',
  hideExtensionRequest = 'hideExtensionRequest',
  hidePasswordForgotten = 'hidePasswordForgotten',
  groupnames= 'groupnames',
  giveExt= 'giveExt',
  hasRoaming= 'hasRoaming',
  hasCrackProtection= 'hasCrackProtection',
  imgBackgroundURL= 'imgBackgroundURL',
  imgBackgroundColor= 'imgBackgroundURL',
  imgBackgroundOption= 'imgBackgroundOption',
  isUsageDisabled= 'isUsageDisabled',
  isWebFilterActive= 'isWebFilterActive',
  isWebLogActive= 'isWebLogActive',
  isNewWebsitesBlocked= 'isNewWebsitesBlocked',
  isAppFilterActive= 'isAppFilterActive',
  isAppFilterNewBlocked= 'isAppFilterNewBlocked',
  isEmailReportActive= 'isEmailReportActive',
  isPasswordLocked= 'isPasswordLocked',
  isForcedBreak= 'isForcedBreak',
  emailReportRecipient= 'emailReportRecipient',
  emailReportCC= 'emailReportCC',
  emailReportSubject= 'emailReportSubject',
  forceFastboot= 'forceFastboot',
  isEmailReportDay= 'isEmailReportDay',
  isEmailReportWeek= 'isEmailReportWeek',
  isEmailReportUnlockMsg= 'isEmailReportUnlockMsg',
  hideUsageAny= 'hideUsageAny',
  hideUsageRuntimePrograms= 'hideUsageRuntimePrograms',
  hideUsageRuntimeWebsites= 'hideUsageRuntimeWebsites',
  hideUsageHistoryPrograms= 'hideUsageHistoryPrograms',
  hideUsageHistoryWebsites= 'hideUsageHistoryWebsites',
  hideUsageHistoryBlocked= 'hideUsageHistoryBlocked',
  hideUsageHistorySystem= 'hideUsageHistorySystem',
  neverBlockAlwaysAllowed= 'neverBlockAlwaysAllowed',
  noBonusNotification= 'noBonusNotification',
  noExtensionInBlockTime= 'noExtensionInBlockTime',
  noExtensionInPause= 'noExtensionInPause',
  noExtensionDeleteAuto= 'noExtensionDeleteAuto',
  noBlockNotification= 'noBlockNotification',
  alwaysBlockNotification = 'alwaysBlockNotification',
  noBlockDualScreen= 'noBlockDualScreen',
  noAppsInBlockTime= 'noAppsInBlockTime',
  noNotificationBar= 'noNotificationBar',
  noProtectSettings= 'noProtectSettings',
  noWhatsappVideo= 'noWhatsappVideo',
  protectSettingsLevel= 'protectSettingsLevel',
  oneSecInterval= 'oneSecInterval',
  webDisableSSL= 'webDisableSSL',
  webBlockedCategory11= 'webBlockedCategory11',
  webBlockedCategory12= 'webBlockedCategory12',
  webBlockedCategory13= 'webBlockedCategory13',
  webBlockedCategory14= 'webBlockedCategory14',
  webBlockedCategory15= 'webBlockedCategory15',
  webBlockedCategory16= 'webBlockedCategory16',
  webBlockedCategory17= 'webBlockedCategory17',
  webBlockedCategory18= 'webBlockedCategory18',
  webBlockedCategory19= 'webBlockedCategory19',
  webBlockedCategory20= 'webBlockedCategory20',
  webBlockedCategory21= 'webBlockedCategory21',
  webBlockedCategory22= 'webBlockedCategory22',
  webBlockedCategory23= 'webBlockedCategory23',
  webBlockedCategory24= 'webBlockedCategory24',
  webBlockedCategory25= 'webBlockedCategory25',
  webBlockedCategory26= 'webBlockedCategory26',
  webBlockedCategory27= 'webBlockedCategory27',
  webBlockedCategory28= 'webBlockedCategory28',
  webBlockedCategory29= 'webBlockedCategory29',
  webBlockedCategory30= 'webBlockedCategory30',
  webBlockedCategory31= 'webBlockedCategory31',
  webBlockedCategory32= 'webBlockedCategory32',
  webBlockedCategory33= 'webBlockedCategory33',
  webBlockedCategory34= 'webBlockedCategory34',
  webBlockedCategory35= 'webBlockedCategory35',
  webFilterAge= 'webFilterAge',
  webFilterAgeNotifyOpt= 'webFilterAgeNotifyOpt',
  isActive= 'isActive',
  blockedUntil= 'blockedUntil',
  defaultAppKind= 'defaultAppKind',
  showAlwaysEntries= 'showAlwaysEntries',
  screenshotInterval= 'screenshotInterval',
  screenshotActive = 'screenshotActive',
  screenshotWifiOnly= 'screenshotWifiOnly',
  screenshotRightSuccess= 'screenshotRightSuccess',
  wakeupDevice = 'wakeupDevice',
  noAudioStop = 'noAudioStop',
  disablePopup = 'disablePopup',
  warnAsToast = 'warnAsToast',
  overrideScreenOn = 'overrideScreenOn',
  overrideOurPkg = 'overrideOurPkg',
  overrideSysApp = 'overrideSysApp',
  overrideDeviceLocked = 'overrideDeviceLocked',
  overrideForeground = 'overrideForeground',
  overridePhone = 'overridePhone',
  overrideNullPkg = 'overrideNullPkg',
  preferAccPkg = 'preferAccPkg',
  appCheckLevel = 'appCheckLevel',
  manipulationDuration = 'manipulationDuration',
  notificationBlockLevel = 'notificationBlockLevel',
  bonusBarPosition = 'bonusBarPosition',
  forcePortraitBlock = 'forcePortraitBlock',
  samsecDisableFactoryReset = 'samsecDisableFactoryReset',
  samsecDisableSafeMode = 'samsecDisableSafeMode',
  samsecDisableDateTime = 'samsecDisableDateTime',
  samsecDisableSettings = 'samsecDisableSettings',
  samsecForceGPS = 'samsecForceGPS',
  samsecDisableAirplaneMode = 'samsecDisableAirplaneMode',
  samsecDisableMultiWindow = 'samsecDisableMultiWindow',
  samsecDisableMultiUser = 'samsecDisableMultiUser',
  samsecDisablePinApp = 'samsecDisablePinApp',
  samsecDisableApps = 'samsecDisableApps',
  samsecWantIt = 'samsecWantIt',
  timecountv2 = 'timecountv2',
  debugterm = 'debugterm',
  disableSplitLock = 'disableSplitLock',
  disableCb3Counting = 'disableCb3Counting',
  hideUnblockRequest = 'hideUnblockRequest',
  tanOffline = 'tanOffline',
  webfilterLevel = 'webfilterLevel',
  isAnySecurity = 'isAnySecurity',
  isSoundLimitGeneral = 'isSoundLimitGeneral',
  isSoundTimeLimitActive = 'isSoundTimeLimitActive',
  isSoundWeekdayLimitActive = 'isSoundWeekdayLimitActive',
  noExtensionInSoundLimit = 'noExtensionInSoundLimit',
  soundLimitDay = 'soundLimitDay',
  soundLimitWeek = 'soundLimitWeek',
  soundLimitMonth = 'soundLimitMonth',
  soundLimitMonday = 'soundLimitMonday',
  soundLimitTuesday = 'soundLimitTuesday',
  soundLimitWednesday = 'soundLimitWednesday',
  soundLimitThursday = 'soundLimitThursday',
  soundLimitFriday = 'soundLimitFriday',
  soundLimitSaturday = 'soundLimitSaturday',
  soundLimitSunday = 'soundLimitSunday',
  soundBlockTimes = 'soundBlockTimes',
  isPlayStoreVersion = 'isPlayStoreVersion',
  showCardSecurityChecks = 'showCardSecurityChecks',
  noAudioStopV2 = 'noAudioStopV2',
  forceUI25 = 'forceUI25',
  forceLegacyOverlay = 'forceLegacyOverlay',
  wideBackground = 'wideBackground'
}




export enum CcSettingsParams {
  IsTimeActive          = 'isTimeActive',
  isTimeLimitActive     = 'isTimeLimitActive',
  TimeLimitDay          = 'timeLimitDay',
  TimeLimitWeek         = 'timeLimitWeek',
  TimeLimitMonth        = 'timeLimitMonth',
  isWeekdayLimitActive  = 'isWeekdayLimitActive',
  TimeLimitMonday       = 'timeLimitMonday',
  TimeLimitTuesday      = 'timeLimitTuesday',
  TimeLimitWednesday    = 'timeLimitWednesday',
  TimeLimitThursday     = 'timeLimitThursday',
  TimeLimitFriday       = 'timeLimitFriday',
  TimeLimitSaturday     = 'timeLimitSaturday',
  TimeLimitSunday       = 'timeLimitSunday',
  blockTimesPC          = 'blockTimesPC',

  // Misc stuff (not from template json)
  isforcedbreak         = 'isforcedbreak',
  hasunlockreq          = 'hasunlockreq',
  unlockdate            = 'unlockdate',
  roaming               = 'roaming',
  onetimelocklevel      = 'onetimelocklevel',
  datetimehack          = 'datetimehack',
  lockdate              = 'lockdate',
  isLatestVersion       = 'isLatestVersion',
  tancount              = 'tancount',

  // CCSetAllDefault.json from template backend
  hasChangedCCSET       = 'hasChangedCCSET',
  isSecDisableSafeBoot  = 'isSecDisableSafeBoot',
  isSecDisableSysRestore= 'isSecDisableSysRestore',
  isSecDisableFastUserSwitching= 'isSecDisableFastUserSwitching',
  SecLevel              = 'SecLevel',
  generalWarn1          = 'generalWarn1',
  generalWarn2          = 'generalWarn2',
  generalWarn3          = 'generalWarn3',
  generalWarn5          = 'generalWarn5',
  generalWarn3Value     = 'generalWarn3Value',
  generalWarn5Value       = 'generalWarn5Value',
  hideViewReports = 'hideViewReports',
  hideViewLimits = 'hideViewLimits',
  hideExtensionRequest = 'hideExtensionRequest',
  hidePasswordForgotten = 'hidePasswordForgotten',
  imgBackgroundURL= 'imgBackgroundURL',
  imgBackgroundColor= 'imgBackgroundColor',
  imgBackgroundOption= 'imgBackgroundOption',
  isGeneralNoDeleteExtensionAuto= 'isGeneralNoDeleteExtensionAuto',
  isGeneralStealthMode= 'isGeneralStealthMode',
  isGeneralAutoHideWarnings= 'isGeneralAutoHideWarnings',
  isGeneralBeepForWarnings= 'isGeneralBeepForWarnings',
  isGeneralNoNewUsers= 'isGeneralNoNewUsers',
  isPasswordLocked= 'isPasswordLocked',
  generalPCLimitLevel= 'generalPCLimitLevel',
generalInternetLimitLevel= 'generalInternetLimitLevel',
  generalForcedBreaksLevel= 'generalForcedBreaksLevel',
  generalPauseTimersLevel= 'generalPauseTimersLevel',
  generalVacationLevel= 'generalVacationLevel',
  generalDeleteLogsLevel= 'generalDeleteLogsLevel',
  generalCountdownLevel= 'generalCountdownLevel',
  noTerminateLockScreen= 'noTerminateLockScreen',
  generalSecLevel= 'generalSecLevel',
  generalBeepValue= 'generalBeepValue',
  groupnames= 'groupnames',
  remoteDebugLevel= 'remoteDebugLevel',
  noAudioStop= 'noAudioStop',
  noAudioStopV2= 'noAudioStopV2',
  noBonusNotification = 'noBonusNotification',
  cloneMode= 'cloneMode',
  // CCSetDefault.json from template backend
  isForcedBreak= 'isForcedBreak',
  forceBreakAfter= 'forceBreakAfter',
  forceBreakDuration= 'forceBreakDuration',
  giveExt= 'giveExt',
  hasRoaming= 'hasRoaming',
  isCountdown= 'isCountdown',
  countdownTime= 'countdownTime',
  OneTimeLockLevel= 'OneTimeLockLevel',
  LockDate= 'LockDate',
  UnlockDate= 'UnlockDate',
  isWebFilterActive= 'isWebFilterActive',
  isWebLogActive= 'isWebLogActive',
  isNewWebsitesBlocked= 'isNewWebsitesBlocked',
  isAppStoreBlocked= 'isAppStoreBlocked',
  extension= 'extension',
  noExtensionInBlockTime= 'noExtensionInBlockTime',
  noAppsInBlockTime= 'noAppsInBlockTime',
  noAppsInPause= 'noAppsInPause',
  noExtensionInPause= 'noExtensionInPause',
  noExtensionDeleteAuto = 'noExtensionDeleteAuto',
  noInject = 'noInject',
  webFilterAge= 'webFilterAge',
  webFilterAgeNotifyOpt= 'webFilterAgeNotifyOpt',
  webNoWarning= 'webNoWarning',
  webNeutralWarning= 'webNeutralWarning',
  webRedirectURL= 'webRedirectURL',
  webNoHttps= 'webNoHttps',
  webNoIP= 'webNoIP',
  webCheckAllowedKeyword= 'webCheckAllowedKeyword',
  webKeywordsSearchOnly= 'webKeywordsSearchOnly',
  webNoDownload= 'webNoDownload',
  webDisableSSL= 'webDisableSSL',
  webRedirect= 'webRedirect',
  webRedirectBlockpage= 'webRedirectBlockpage',
  webRedirectUrl= 'webRedirectUrl',
  webdeepscan= 'webdeepscan',
  webNoDynamicWhitelist= 'webNoDynamicWhitelist',
  webKeywordsGlobal = 'webKeywordsGlobal',
  webFilterAllApps = 'webFilterAllApps',
  isPrgFilterActive= 'isPrgFilterActive',
  isPrgFilterNewBlocked= 'isPrgFilterNewBlocked',
  programFilterAge= 'programFilterAge',
  programFilterAgeNotifyOpt= 'programFilterAgeNotifyOpt',
  isDisableCMD= 'isDisableCMD',
  isDisableRegedit= 'isDisableRegedit',
  isDisableControlPanel= 'isDisableControlPanel',
  isDisableUserAccounts= 'isDisableUserAccounts',
  isDisableStartRun= 'isDisableStartRun',
  isDisableStartSearch= 'isDisableStartSearch',
  isDisableTaskmanager= 'isDisableTaskmanager',
  isDisableIcon= 'isDisableIcon',
  isDisableMSStore= 'isDisableMSStore',
  isDisableTimeDate= 'isDisableTimeDate',
  isDisableLockStation= 'isDisableLockStation',
  isNoDeleteChicoSys= 'isNoDeleteChicoSys',
  isNoDeleteChicoStart= 'isNoDeleteChicoStart',
  isUsageDisabled= 'isUsageDisabled',
  defaultAppKind= 'defaultAppKind',
  DrvLock= 'DrvLock',
  isEmailReportActive= 'isEmailReportActive',
  emailReportRecipient= 'emailReportRecipient',
  emailReportCC= 'emailReportCC',
  emailReportSubject= 'emailReportSubject',
  isEmailReportDay= 'isEmailReportDay',
  isEmailReportWeek= 'isEmailReportWeek',
  isEmailReportUnlockMsg= 'isEmailReportUnlockMsg',
  isEmailReportStart= 'isEmailReportStart',
  isEmailReportStop= 'isEmailReportStop',
  isEmailReportSystemMsg= 'isEmailReportSystemMsg',
  NFSOff= 'NFSOff',
  noCheckUrlFallback = 'noCheckUrlFallback',
  nfsAutoInetPRG= 'nfsAutoInetPRG',
  screenshotactive= 'screenshotactive',
  screenshotinterval= 'screenshotinterval',
  hideUsageAny= 'hideUsageAny',
  hideUsageRuntimePrograms= 'hideUsageRuntimePrograms',
  hideUsageRuntimeWebsites= 'hideUsageRuntimeWebsites',
  hideUsageHistoryPrograms= 'hideUsageHistoryPrograms',
  hideUsageHistoryWebsites= 'hideUsageHistoryWebsites',
  hideUsageHistoryBlocked= 'hideUsageHistoryBlocked',
  hideUsageHistorySystem= 'hideUsageHistorySystem',
  webBlockedCategory11= 'webBlockedCategory11',
  webBlockedCategory12= 'webBlockedCategory12',
  webBlockedCategory13= 'webBlockedCategory13',
  webBlockedCategory14= 'webBlockedCategory14',
  webBlockedCategory15= 'webBlockedCategory15',
  webBlockedCategory16= 'webBlockedCategory16',
  webBlockedCategory17= 'webBlockedCategory17',
  webBlockedCategory18= 'webBlockedCategory18',
  webBlockedCategory19= 'webBlockedCategory19',
  webBlockedCategory20= 'webBlockedCategory20',
  webBlockedCategory21= 'webBlockedCategory21',
  webBlockedCategory22= 'webBlockedCategory22',
  webBlockedCategory23= 'webBlockedCategory23',
  webBlockedCategory24= 'webBlockedCategory24',
  webBlockedCategory25= 'webBlockedCategory25',
  webBlockedCategory26= 'webBlockedCategory26',
  webBlockedCategory27= 'webBlockedCategory27',
  webBlockedCategory28= 'webBlockedCategory28',
  webBlockedCategory29= 'webBlockedCategory29',
  webBlockedCategory30= 'webBlockedCategory30',
  webBlockedCategory31= 'webBlockedCategory31',
  webBlockedCategory32= 'webBlockedCategory32',
  webBlockedCategory33= 'webBlockedCategory33',
  webBlockedCategory34= 'webBlockedCategory34',
  webBlockedCategory35= 'webBlockedCategory35',
  winuserchange= 'winuserchange',
  warnAsToast = 'warnAsToast',

  overrideScreenOn = 'overrideScreenOn',
  overrideOurPkg = 'overrideOurPkg',
  overrideSysApp = 'overrideSysApp',
  overrideDeviceLocked = 'overrideDeviceLocked',
  overrideForeground = 'overrideForeground',
  overridePhone = 'overridePhone',
  overrideNullPkg = 'overrideNullPkg',
  preferAccPkg = 'preferAccPkg',
  appCheckLevel = 'appCheckLevel',
  oneSecInterval = 'oneSecInterval',
  manipulationDuration = 'manipulationDuration',
  bonusBarPosition = 'bonusBarPosition',
  forcePortaitBlock = 'forcePortaitBlock',
  timecountv2 = 'timecountv2',
  debugterm = 'debugterm',
  disableCb3Counting = 'disableCb3Counting',
  hideUnblockRequest = 'hideUnblockRequest',
  tanOffline = 'tanOffline',
  webfilterLevel = 'webfilterLevel',
  neverBlockAlwaysAllowed = 'neverblockalwaysallowed',
  isAnySecurity = 'isAnySecurity',
  showCardSecurityChecks = 'showCardSecurityChecks',
  webSafeSearch = 'webSafeSearch',
  forceUI25 = 'forceUI25',
  forceLegacyOverlay = 'forceLegacyOverlay',
  wideBackground = 'wideBackground'
}

